import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import ElementUI from "element-ui";
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css"; // 这个nprogress样式必须引入


import axios from "axios";
import echarts from "echarts";
import ZkTable from "vue-table-with-tree-grid";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme
import { hasPermission } from "./utils/permissionDirect";
import GetPageListData from "./utils/getPageListData";
import ScheduleMethods from "./utils/scheduleMethods";
import ObjectMethods from "./utils/objectMethods";
import TableMethods from "./utils/tableMethods";
import Constants from "./utils/constants";
import "./font/font.css"; //字体
import './assets/iconfont/font.css'
import "xe-utils"; //表格
import VXETable from "vxe-table";
import VXETablePluginExportXLSX from "vxe-table-plugin-export-xlsx";
import VXETablePluginElement from "vxe-table-plugin-element";
import "vxe-table-plugin-element/dist/style.css";
import Global from "./utils/Global";
import MessageInfo from "./utils/message";
import i18n from "./i18n/i18n";
import "vxe-table/lib/style.css";
import "element-ui/lib/theme-chalk/index.css";
import "./components/style/btn.css";
import router from "./router";
import "default-passive-events";
import { getTabsIsUsedResult } from "./utils/getTabsIsUsedResult.js";

import "./mixins";
// import {Base64} from 'js-base64'

Vue.prototype.Global = Global;
Vue.prototype.Constants = Constants;
Vue.prototype.$getTabsIsUsedResult = getTabsIsUsedResult;
Vue.prototype.MessageInfo = MessageInfo;

VXETable.setup({
  table: {
    emptyText: i18n.t("message.title.emptyText"),
    allFilter: i18n.t("message.title.allFilter"),
  },
  i18n: (key, args) => i18n.t(key, args),
});

const Plugins = [hasPermission];
Plugins.map((plugin) => {
  Vue.use(plugin);
});
VXETable.use(VXETablePluginExportXLSX);
VXETable.use(VXETablePluginElement);
Vue.use(VXETable);
Vue.use(VueQuillEditor);
Vue.use(ZkTable);
Vue.use(echarts);
Vue.use(GetPageListData);
Vue.use(ScheduleMethods);
Vue.use(Global);
Vue.use(ObjectMethods);
Vue.use(TableMethods);


// Vue.use(Base64)

NProgress.configure({ ease: "ease", speed: 500 });
NProgress.configure({ minimum: 0.3 });
Vue.prototype.$http = axios;

Vue.prototype.$echarts = echarts;

//这是线上的API接口,如果使用本地的可以注释选择本地的服务

// axios.defaults.baseURL = 'https://www.zykhome.club/pmdm/'
//axios.defaults.baseURL = 'http://DESKTOP-Bin:8001/' //大师地址
//axios.defaults.baseURL = 'http://192.168.1.167:8001/' //大师地址
//axios.defaults.baseURL = 'http://192.168.1.193:8001/'//zhengnian地址
//axios.defaults.baseURL = 'http://127.0.0.1:8001/'//本地
//axios.defaults.baseURL = 'http://192.168.1.159:8001/' //线上地址
//axios.defaults.baseURL = 'http://58.211.23.183:6025/' //线上地址
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

/**
 *  axios请求拦截器
 */
axios.interceptors.request.use(
  (config) => {
    // console.log(config);
    NProgress.start(); // 设置加载进度条(开始..)
    config.headers.Token = window.sessionStorage.getItem("swift_TOKEN");
    config.headers.TenantId = window.sessionStorage.getItem("tenantId");
    return config;
    //console.log(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * axios响应拦截器
 */
axios.interceptors.response.use(
  (res) => {
    // console.log(res);
    NProgress.done(); // 设置加载进度条(结束..)
    if (res.data.code == 401) {
      //如果返回的code==401说明token错误或者token过期
      // window.localStorage.clear();
      var vm = new Vue();
      vm.$message.error(res.data.message); //"您的登入状态已失效,请您重新登入~"
      return router.push("/index");
    } else if (
      !!res.data.code &&
      res.data.code != 200 &&
      res.data.code !== 911
    ) {
      var vm = new Vue();
      vm.$message.error(res.data.message);
      return res;
    } else {
      return res;
    }
  },

  (error) => {
    console.log(error);
    let vm = new Vue();

    // console.log(vm);
    // let message = vm.$t('message.error.commonServerError');
    // console.log(message);
    // vm.$message.error(message);

    vm.$message.error("出现错误，请联系管理员。");
    // console.log(error);

    return Promise.reject(error);
  }
);

/**
 * 自定义权限指令
 */

Vue.config.productionTip = false;
// Vue.use(ElementUI)
Vue.use(ElementUI, { size: "small", zIndex: 3000 });
var vue = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
